import { useState, createContext, Dispatch, SetStateAction } from "react";

interface Props {
  children: React.ReactNode;
}

export type ToastStore = {
  isOpenSetting: boolean;
  setIsOpenSetting: Dispatch<SetStateAction<boolean>>;
  title: string;
  setTitle: Dispatch<SetStateAction<string>>;
  showSearchBar: boolean;
  setShowSearchBar: Dispatch<SetStateAction<boolean>>;
  noteModified: boolean;
  setNoteModified: Dispatch<SetStateAction<boolean>>;
  projectPageNumber: number;
  setProjectPageNumber: Dispatch<SetStateAction<number>>;
};

const placeholder = {} as ToastStore;
export const StatusContext = createContext<ToastStore>(placeholder);

export function StatusProvider(props: Props) {
  const [projectPageNumber, setProjectPageNumber] = useState<number>(0);
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const [noteModified, setNoteModified] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(true);
  const [title, setTitle] = useState<string>("Projects");

  return (
    <StatusContext.Provider
      value={{
        isOpenSetting,
        setIsOpenSetting,
        title,
        setTitle,
        showSearchBar,
        setShowSearchBar,
        noteModified,
        setNoteModified,
        projectPageNumber,
        setProjectPageNumber,
      }}
    >
      <>{props.children}</>
    </StatusContext.Provider>
  );
}
